import { Component, ChangeDetectionStrategy, Input, OnInit } from '@angular/core';
import { AgendaItem, AgendaSection } from '@modules/content-api/adapter/agenda.adapter';

@Component({
  selector: 'mb-agenda-section',
  templateUrl: './agenda-section.component.html',
  styleUrls: ['./agenda-section.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AgendaSectionComponent implements OnInit {
  @Input() agenda!: AgendaSection;

  public agendaDaysMap: {
    [day: string]: {
      isOpen: boolean;
      agendaItems: AgendaItem[];
    };
  } = {};

  constructor() {}

  ngOnInit() {
    this.agenda.agendaItems.forEach((agendaItem) => {
      if (!this.agendaDaysMap[agendaItem.day]) {
        this.agendaDaysMap[agendaItem.day] = {
          isOpen: false,
          agendaItems: [agendaItem],
        };
      } else {
        this.agendaDaysMap[agendaItem.day].agendaItems.push(agendaItem);
      }
    });

    // TODO: map days to user's attendance data

    // open the first accordion.
    // TODO: It should open the "current day", if we can match it to the attendance
    const firstKey = Object.keys(this.agendaDaysMap).shift();
    if (firstKey) {
      this.agendaDaysMap[firstKey].isOpen = true;
    }

    // TODO: update section data on change?
  }
}
